module.exports = __webpack_public_path__ + "static/img/btn_sp_close.7c6de3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_sp_close.png
// module id = KQsf
// module chunks = 0